import { AngularComponentsModule } from '@abgov/angular-components';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FacilityBedsEditorAction } from '../../components/facility-beds-editor-action/facility-beds-editor-action';
import { FacilityBedsGrid } from '../../components/facility-beds-grid/facility-beds-grid';
import { FacilityReportingPeriod } from '../../components/facility-reporting-period/facility-reporting-period';
@Component({
  selector: 'app-facility-beds-editor-page',
  imports: [
    CommonModule,
    AngularComponentsModule,
    FacilityReportingPeriod,
    FacilityBedsEditorAction,
    FacilityBedsGrid,
  ],
  templateUrl: './facility-beds-editor-page.html',
  styleUrl: './facility-beds-editor-page.scss',
})
export class FacilityBedsEditorPage {}
